// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrderActionsSection_order__CmWaV {
  color: var(--darkGray);
}

.OrderActionsSection_header__Rp8or {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5px;
}

.OrderActionsSection_title__rfYz1 {
  font-family: BebasNeue;
  font-weight: 700;
  color: var(--darkGray);
  font-size: 20px;
}

.OrderActionsSection_green__WywUM {
  color: var(--orange);
}

.OrderActionsSection_clientInfo__0A60v {
  background-color: var(--darkGray);
  color: white;
  padding: 10px 20px;
  font-weight: 500;
  margin-top: 5px;
  margin-bottom: 25px;
}

.OrderActionsSection_clientDetail__L0SfE {
  display: block;
}

.OrderActionsSection_labelClient__-a6RE {
  display: inline-block;
  margin-right: 5px;
}

.OrderActionsSection_clientAddress__yZ4xB {
  text-align: center;
}

.OrderActionsSection_clientPhone__6F95\\+ {
  text-align: right;
}

.OrderActionsSection_products__r35k3 {
  margin-bottom: 15px;
}

.OrderActionsSection_product__ik2qs {
  border-bottom: 1px dashed #bfbfbf;
  padding-bottom: 20px;
  margin-bottom: 15px;
}

.OrderActionsSection_productName__gttfu {
  font-family: BebasNeue;
  font-size: 18px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.OrderActionsSection_bullet__XJUXO {
  display: inline-block;
  margin-right: 8px;
}

.OrderActionsSection_details__-NSs9 {
  padding-left: 25px;
  margin-top: 5px;
}

.OrderActionsSection_details__-NSs9 span {
  display: block;
}

.OrderActionsSection_totalProduct__KyQpi {
  display: flex;
  justify-content: flex-end;
  padding: 0 15px;
}

.OrderActionsSection_price__6ydQJ {
  font-weight: 500;
}

.OrderActionsSection_annotations__PhFDU {
  margin: 25px 0;
  color: var(--darkGray);
}

.OrderActionsSection_labelNotes__y7sDo {
  font-weight: 700;
}

.OrderActionsSection_labelSection__bI012 {
  font-family: BebasNeue;
  font-weight: 700;
  margin-bottom: 5px;
  display: block;
}

.OrderActionsSection_methodWrap__f35Yr {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 15px;
  border-top: 1px solid #c2c2c2;
  color: #444444;
}

.OrderActionsSection_methodWrap__f35Yr:last-child {
  border-bottom: 1px solid #c2c2c2;
}

.OrderActionsSection_method__NdwOO {
  display: flex;
  align-items: center;
}

.OrderActionsSection_methodIcon__qgh5E {
  margin-right: 15px;
}

.OrderActionsSection_cashback__cfupJ {
  font-weight: 700;
}

.OrderActionsSection_paymentWrap__r2EOi {
  margin-bottom: 30px;
}

.OrderActionsSection_driverName__a-L5p {
  font-weight: 700;
}

.OrderActionsSection_selectDriver__AXo5x {
  width: 100%;
  border-color: #d2d2d2;
  background-color: #fbfbfb;
}

.OrderActionsSection_selectDriver__AXo5x .OrderActionsSection_ant-select-selector__sRDDH {
  border-radius: 6px !important;
}

.OrderActionsSection_driverAssign__F1JRf,
.OrderActionsSection_accept__345U5 {
  font-weight: 700;
  font-size: 12px;
}

.OrderActionsSection_driverAssign__F1JRf {
  margin: 0 auto;
  display: block;
  width: 100%;
}

.OrderActionsSection_submitWrap__xCi56 {
  margin-top: 40px;
  display: flex;
  justify-content: flex-end;
}

.OrderActionsSection_accept__345U5 {
  min-width: 160px;
}

.OrderActionsSection_mainInfoWrap__u1IpU {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.OrderActionsSection_call__CWHib {
  padding: 5px 15px;
  background-color: var(--orange);
  color: white;
  font-weight: 700;
  margin-left: 20px;
  border-radius: 4px;
  display: block;
}

.OrderActionsSection_peyaIconText__Kp9pG {
  display: inline-block;
  margin-right: 2em;
}

@media only screen and (max-width: 992px) {
  .OrderActionsSection_clientAddress__yZ4xB {
    text-align: left;
  }

  .OrderActionsSection_clientPhone__6F95\\+ {
    text-align: left;
    color: #444444;
  }

  .OrderActionsSection_labelClient__-a6RE {
    display: block;
    color: var(--darkGray);
    font-size: 12px;
  }

  .OrderActionsSection_clientDetail__L0SfE {
    margin-bottom: 15px;
  }

  .OrderActionsSection_clientInfo__0A60v {
    background-color: transparent;
    color: #444444;
    font-weight: 500;
    font-size: 13px;
    padding-left: 0;
  }

  .OrderActionsSection_submitWrap__xCi56 {
    width: 100%;
  }

  .OrderActionsSection_accept__345U5 {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/styles/OrderActionsSection.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,6BAA6B;IAC7B,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".order {\n  color: var(--darkGray);\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 5px;\n}\n\n.title {\n  font-family: BebasNeue;\n  font-weight: 700;\n  color: var(--darkGray);\n  font-size: 20px;\n}\n\n.green {\n  color: var(--orange);\n}\n\n.clientInfo {\n  background-color: var(--darkGray);\n  color: white;\n  padding: 10px 20px;\n  font-weight: 500;\n  margin-top: 5px;\n  margin-bottom: 25px;\n}\n\n.clientDetail {\n  display: block;\n}\n\n.labelClient {\n  display: inline-block;\n  margin-right: 5px;\n}\n\n.clientAddress {\n  text-align: center;\n}\n\n.clientPhone {\n  text-align: right;\n}\n\n.products {\n  margin-bottom: 15px;\n}\n\n.product {\n  border-bottom: 1px dashed #bfbfbf;\n  padding-bottom: 20px;\n  margin-bottom: 15px;\n}\n\n.productName {\n  font-family: BebasNeue;\n  font-size: 18px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.bullet {\n  display: inline-block;\n  margin-right: 8px;\n}\n\n.details {\n  padding-left: 25px;\n  margin-top: 5px;\n}\n\n.details span {\n  display: block;\n}\n\n.totalProduct {\n  display: flex;\n  justify-content: flex-end;\n  padding: 0 15px;\n}\n\n.price {\n  font-weight: 500;\n}\n\n.annotations {\n  margin: 25px 0;\n  color: var(--darkGray);\n}\n\n.labelNotes {\n  font-weight: 700;\n}\n\n.labelSection {\n  font-family: BebasNeue;\n  font-weight: 700;\n  margin-bottom: 5px;\n  display: block;\n}\n\n.methodWrap {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 15px;\n  border-top: 1px solid #c2c2c2;\n  color: #444444;\n}\n\n.methodWrap:last-child {\n  border-bottom: 1px solid #c2c2c2;\n}\n\n.method {\n  display: flex;\n  align-items: center;\n}\n\n.methodIcon {\n  margin-right: 15px;\n}\n\n.cashback {\n  font-weight: 700;\n}\n\n.paymentWrap {\n  margin-bottom: 30px;\n}\n\n.driverName {\n  font-weight: 700;\n}\n\n.selectDriver {\n  width: 100%;\n  border-color: #d2d2d2;\n  background-color: #fbfbfb;\n}\n\n.selectDriver .ant-select-selector {\n  border-radius: 6px !important;\n}\n\n.driverAssign,\n.accept {\n  font-weight: 700;\n  font-size: 12px;\n}\n\n.driverAssign {\n  margin: 0 auto;\n  display: block;\n  width: 100%;\n}\n\n.submitWrap {\n  margin-top: 40px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.accept {\n  min-width: 160px;\n}\n\n.mainInfoWrap {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.call {\n  padding: 5px 15px;\n  background-color: var(--orange);\n  color: white;\n  font-weight: 700;\n  margin-left: 20px;\n  border-radius: 4px;\n  display: block;\n}\n\n.peyaIconText {\n  display: inline-block;\n  margin-right: 2em;\n}\n\n@media only screen and (max-width: 992px) {\n  .clientAddress {\n    text-align: left;\n  }\n\n  .clientPhone {\n    text-align: left;\n    color: #444444;\n  }\n\n  .labelClient {\n    display: block;\n    color: var(--darkGray);\n    font-size: 12px;\n  }\n\n  .clientDetail {\n    margin-bottom: 15px;\n  }\n\n  .clientInfo {\n    background-color: transparent;\n    color: #444444;\n    font-weight: 500;\n    font-size: 13px;\n    padding-left: 0;\n  }\n\n  .submitWrap {\n    width: 100%;\n  }\n\n  .accept {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"order": `OrderActionsSection_order__CmWaV`,
	"header": `OrderActionsSection_header__Rp8or`,
	"title": `OrderActionsSection_title__rfYz1`,
	"green": `OrderActionsSection_green__WywUM`,
	"clientInfo": `OrderActionsSection_clientInfo__0A60v`,
	"clientDetail": `OrderActionsSection_clientDetail__L0SfE`,
	"labelClient": `OrderActionsSection_labelClient__-a6RE`,
	"clientAddress": `OrderActionsSection_clientAddress__yZ4xB`,
	"clientPhone": `OrderActionsSection_clientPhone__6F95+`,
	"products": `OrderActionsSection_products__r35k3`,
	"product": `OrderActionsSection_product__ik2qs`,
	"productName": `OrderActionsSection_productName__gttfu`,
	"bullet": `OrderActionsSection_bullet__XJUXO`,
	"details": `OrderActionsSection_details__-NSs9`,
	"totalProduct": `OrderActionsSection_totalProduct__KyQpi`,
	"price": `OrderActionsSection_price__6ydQJ`,
	"annotations": `OrderActionsSection_annotations__PhFDU`,
	"labelNotes": `OrderActionsSection_labelNotes__y7sDo`,
	"labelSection": `OrderActionsSection_labelSection__bI012`,
	"methodWrap": `OrderActionsSection_methodWrap__f35Yr`,
	"method": `OrderActionsSection_method__NdwOO`,
	"methodIcon": `OrderActionsSection_methodIcon__qgh5E`,
	"cashback": `OrderActionsSection_cashback__cfupJ`,
	"paymentWrap": `OrderActionsSection_paymentWrap__r2EOi`,
	"driverName": `OrderActionsSection_driverName__a-L5p`,
	"selectDriver": `OrderActionsSection_selectDriver__AXo5x`,
	"ant-select-selector": `OrderActionsSection_ant-select-selector__sRDDH`,
	"driverAssign": `OrderActionsSection_driverAssign__F1JRf`,
	"accept": `OrderActionsSection_accept__345U5`,
	"submitWrap": `OrderActionsSection_submitWrap__xCi56`,
	"mainInfoWrap": `OrderActionsSection_mainInfoWrap__u1IpU`,
	"call": `OrderActionsSection_call__CWHib`,
	"peyaIconText": `OrderActionsSection_peyaIconText__Kp9pG`
};
export default ___CSS_LOADER_EXPORT___;
